import { createQueryNumberToggleHook } from "../../../../../stores/useQueryState";

export const useTirePricingParamName = "price";

export const useTirePricing = createQueryNumberToggleHook(
  useTirePricingParamName,
  []
);
